'use client'
import { redirect, useParams, useSearchParams } from "next/navigation"
import { useEffect } from "react"

type ComponentProps = {
    isIOS: boolean,
    isAndroid: boolean,
    ip: string
}

export default function RedirectionComponent({ isIOS, isAndroid, ip }: ComponentProps) {

    const params = useSearchParams()


    useEffect(() => {

        const isAstromatik = params.get('callback')

        async function getLogForAstromatik() {

            const check = await fetch(
                `${process.env.NEXT_PUBLIC_API_URL}/items/astromatikLog?filter[ip][_eq]=${ip}&filter[device][_eq]=${!isIOS && !isAndroid ? "other" : isIOS ? "ios" : "android"}`
            );
            const data = await check.json();

            if (data.data.length > 0) {

                await fetch(
                    `${process.env.NEXT_PUBLIC_API_URL}/items/astromatikLog/${data.data[0].id}`,
                    {
                        method: "PATCH",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            created: new Date(),
                            device: !isIOS && !isAndroid ? "other" : isIOS ? "ios" : "android"
                        })
                    }
                );

            } else {

                await fetch(`${process.env.NEXT_PUBLIC_API_URL}/items/astromatikLog`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        created: new Date(),
                        device: !isIOS && !isAndroid ? "other" : isIOS ? "ios" : "android",
                        ip
                    })
                });

            }

            if (isIOS) {
                redirect('https://apps.apple.com/kz/app/gyno-club/id6758295860')
            } else if (isAndroid) {
                redirect('https://play.google.com/store/apps/details?id=com.gynoclubapp')
            }
        }

        if (isAstromatik) {
            getLogForAstromatik()
        }

        if (!isAstromatik) {
            if (isIOS) {
                redirect('https://apps.apple.com/kz/app/gyno-club/id6758295860')
            } else if (isAndroid) {
                redirect('https://play.google.com/store/apps/details?id=com.gynoclubapp')
            }
        }

    }, [])
    return (
        <div />
    )
}